export default {
	SET_LOADING: 'SET_LOADING'
}
